import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Close } from '@indriver/mireska';
import { Box, Title, PrefixBox, PostfixBox, RoundBox } from './bottom-sheet-header.styles.js';

var _RoundBox;

var _excluded = ["children", "title"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];
var BottomSheetHeader = function BottomSheetHeader(props) {
  var children = props.children,
      title = props.title,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React__default.createElement(Box, attrs, /*#__PURE__*/React__default.createElement(Title, {
    type: "h2"
  }, title), children);
};
var BottomSheetHeaderPrefix = function BottomSheetHeaderPrefix(props) {
  var children = props.children,
      attrs = _objectWithoutPropertiesLoose(props, _excluded2);

  return /*#__PURE__*/React__default.createElement(PrefixBox, _extends({
    type: "button"
  }, attrs), children);
};
var BottomSheetHeaderPostfix = function BottomSheetHeaderPostfix(props) {
  var children = props.children,
      attrs = _objectWithoutPropertiesLoose(props, _excluded3);

  return /*#__PURE__*/React__default.createElement(PostfixBox, _extends({
    type: "button"
  }, attrs), children);
};
var BottomSheetCloseIcon = function BottomSheetCloseIcon() {
  return _RoundBox || (_RoundBox = /*#__PURE__*/React__default.createElement(RoundBox, null, /*#__PURE__*/React__default.createElement(Close, {
    size: 20
  })));
};

export { BottomSheetCloseIcon, BottomSheetHeader, BottomSheetHeaderPostfix, BottomSheetHeaderPrefix };
